module.exports = __webpack_public_path__ + "img/ds_5.3cd9c2f4.jpg";